import { render, staticRenderFns } from "./ApplicationsDetailsPreferences.vue?vue&type=template&id=65e75e3e"
import script from "./ApplicationsDetailsPreferences.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetailsPreferences.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetailsPreferences.vue?vue&type=style&index=0&id=65e75e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports